<template>
    <div class="formulate-option-selector" v-if="context">
        <v-select ref="select" :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type" :modelValue="context._value" @update:modelValue="handleInput" :options="context.options || []" :reduce="(x) => x.value" v-bind="context.attrs" :placeholder="context.attrs?.placeholder || '- Selecteer -'" label="label" :appendToBody="true" :calculatePosition="calculateSelectPosition" @close="onClose" @open="onOpen">
            <template #selected-option-container="{ multiple, option }">
                <span v-if="multiple" class="noRender"></span>
                <span :class="`formulate-input-element--${context.type}__selected`" v-else>{{ option.label }}</span>
            </template>

            <template #option="{ label }">
                <div class="formulate-option-selector__option">
                    <span class="option-label" v-html="label"></span>
                    <span class="icon icon--check--filled--inverted icon--shakespeare option-check"></span>
                </div>
            </template>

            <template v-slot:no-options>
                {{ emptyMessage }}
            </template>

            <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="attributes.placeholder || '- Selecteer -'" />
            </template>
        </v-select>
        <div class="formulate-option-selector__options" v-if="localValue && localValue.length">
            <div @click="onOptionClick(option)" v-for="option in selectedOptions" :key="option.value" class="button--option button">
                <span class="icon icon--cross icon--dark">remove</span>
                <span v-html="option.label"></span>
            </div>
        </div>
    </div>
</template>

<script src="./FormulateOptionSelector.js"></script>
